import { Table } from 'antd'
import styled from 'styled-components'

const StyledLocationsTable = styled(Table)`
  margin-top: 24px;
`

export default StyledLocationsTable
